import { defineStore } from "pinia";

export const useTokenStore = defineStore("token", {
  state: () => ({
    _id: "",
    _idToken: "",
    _idTokenExp: 0,
    _refreshToken: "",
  }),
  getters: {
    id: (state) => state._id,
    idToken: (state) => state._idToken,
    idTokenExp: (state) => state._idTokenExp,
    refreshToken: (state) => state._refreshToken,
  },
  actions: {
    setToken(
      id: string,
      idToken: string,
      idTokenExp: number,
      refreshToken: string
    ) {
      this._id = id;
      this._idToken = idToken;
      this._idTokenExp = idTokenExp;
      this._refreshToken = refreshToken;
    },
  },
  persist: {
    enabled: true,
  },
});
